import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src160984950/src/src/ui/components/AttractionsContent/AttractionsContent.tsx");
